var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfiguracionDeProducto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67.3 67.3",
    style: {
      enableBackground: "new 0 0 67.3 67.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#95D4E9;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#FFFFFF;stroke:#95D4E9;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Configuraci\\xF3n_de_producto",
    transform: "translate(-47.5 -815.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19054",
    className: "st0",
    d: "M64.6,824.6L64.6,824.6L60,820l-8,8l4.6,4.6c-0.6,1.2-1.2,2.5-1.6,3.8h-6.5v11.4H55 c0.5,1.3,1,2.5,1.6,3.8l-4.6,4.6l8,8l4.6-4.6c1.2,0.6,2.5,1.2,3.8,1.6v6.5h11.3v-6.5c1.3-0.4,2.6-0.9,3.8-1.6l4.6,4.6l8-8l-4.6-4.6 v0c0.6-1.2,1.2-2.5,1.6-3.8h6.5v-11.4h-6.5c-0.4-1.3-0.9-2.6-1.6-3.8l4.6-4.6l-8-8l-4.6,4.6h0c-1.2-0.6-2.5-1.2-3.8-1.6v-6.5H68.4 v6.5C67.1,823.4,65.8,823.9,64.6,824.6L64.6,824.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19055",
    className: "st0",
    d: "M102.7,837.6l7.7,7.7l-4.4,4.4c0.6,1.2,1.1,2.4,1.5,3.6h6.2v10l-5.9,0.4l-1.6,3.3l5.4,4.3 l-6.8,7.3l-4.4-4.1c-1.2,0.6-2.4,1-3.6,1.4v5.8H85.4v-5.6c-1.1-0.3-2.2-0.8-3.2-1.3l-3.9,3.9l-6.9-6.9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1768",
    className: "st1",
    cx: 74.5,
    cy: 842.5,
    r: 9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguracionDeProducto);
export default __webpack_public_path__ + "static/media/Configuracion-de-producto.9b67d77915960733bb8ddae0287064dd.svg";
export { ForwardRef as ReactComponent };